import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        header: {
          companyName: "SARL BELAMRI INCHA TAAMIR",
          projects: "Projects",
          contact: "Contact Us",
        },
        hero: {
          slogan: "Building the Future",
          learnMore: "Learn More",
        },
        about: {
          title: "Our Projects",
          description:
            "Discover our portfolio of construction projects showcasing quality craftsmanship and modern designs.",
        },
        contactForm: {
          title: "Contact Us",
          name: "Your Name",
          email: "Your Email",
          phone: "Your Phone Number",
          message: "Your Message",
          send: "Send",
          sending: "Sending...",
          success: "Thank you for your message! We will get back to you soon.",
          error:
            "An error occurred while sending the message. Please try again.",
        },
        projectGallery: {
          title: "Our Latest Projects",
        },
        stickyButton: { contact: "Contact Us" },
        location: {
          title: "Our Location",
          description: "Visit us at our office in Hydra, Algiers",
          mapTitle: "Sarl Bel Amri Location",
        },
        footer: {
          companyName: "SARL BELAMRI INCHA TAAMIR",
          address: "Cité Val D'Hydra Bt B Local 1, Hydra - Alger",
          phone1: "06 61 60 04 44",
          phone2: "05 61 62 50 49",
          faxNumber: "020 06 93 85",
          rights: "All rights reserved.",
        },
      },
    },
    fr: {
      translation: {
        header: {
          companyName: "SARL BELAMRI INCHA TAAMIR",
          projects: "Projets",
          contact: "Contactez-nous",
        },
        hero: {
          slogan: "Construire l'avenir",
          learnMore: "En savoir plus",
        },
        about: {
          title: "Nos Projets",
          description:
            "Découvrez notre portefeuille de projets de construction mettant en valeur la qualité artisanale et les designs modernes.",
        },
        contactForm: {
          title: "Contactez-nous",
          name: "Votre Nom",
          email: "Votre Email",
          phone: "Votre Numéro de Téléphone",
          message: "Votre Message",
          send: "Envoyer",
          sending: "Envoi en cours...",
          success: "Merci pour votre message ! Nous vous répondrons bientôt.",
          error:
            "Une erreur est survenue lors de l'envoi du message. Veuillez réessayer.",
        },
        projectGallery: {
          title: "Nos Derniers Projets",
        },
        stickyButton: { contact: "Contactez-nous" },
        location: {
          title: "Notre Emplacement",
          description: "Visitez-nous dans nos bureaux à Hydra, Alger",
          mapTitle: "Emplacement de Sarl Bel Amri",
        },
        footer: {
          companyName: "SARL BELAMRI INCHA TAAMIR",
          address: "Cité Val D'Hydra Bt B Local 1, Hydra - Alger",
          phone1: "06 61 60 04 44",
          phone2: "05 61 62 50 49",
          faxNumber: "020 06 93 85",
          rights: "Tous droits réservés.",
        },
      },
    },
    ar: {
      translation: {
        header: {
          companyName: "ش.ذ.م.م بلعمري للإنشاء و التعمير",
          projects: "المشاريع",
          contact: "اتصل بنا",
        },
        hero: {
          slogan: "نبني المستقبل",
          learnMore: "تعرف أكثر",
        },
        about: {
          title: "مشاريعنا",
          description:
            " اكتشف محفظة مشاريعنا الإنشائية التي تعرض الحرفية العالية والتصاميم الحديثة",
        },
        contactForm: {
          title: "اتصل بنا",
          name: "اسمك",
          email: "بريدك الإلكتروني",
          phone: "رقم هاتفك",
          message: "رسالتك",
          send: "إرسال",
          sending: "...جاري الإرسال",
          success: "شكرًا لرسالتك! سنتواصل معك قريبًا.",
          error: "حدث خطأ أثناء إرسال الرسالة. يرجى المحاولة مرة أخرى.",
        },
        projectGallery: {
          title: "أحدث مشاريعنا",
        },
        stickyButton: { contact: "اتصل بنا" },
        location: {
          title: "موقعنا",
          description: "قم بزيارتنا في مكتبنا في حيدرة، الجزائر",
          mapTitle: "موقع سارل بلعمري",
        },
        footer: {
          companyName: "شركة بلعمري للإنشاء و التعمير",
          address: " حي واد حيدرة عمارة ب محل رقم 1, حيدرة, الجزائر العاصمة",
          phone1: "06 61 60 04 44",
          phone2: "05 61 62 50 49",
          faxNumber: "020 06 93 85",
          rights: "جميع الحقوق محفوظة.",
        },
      },
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

// Dynamically set direction for RTL
i18n.on("languageChanged", (lng) => {
  if (lng === "ar") {
    document.documentElement.setAttribute("dir", "rtl");
  } else {
    document.documentElement.setAttribute("dir", "ltr");
  }
});

export default i18n;
